<template>
    <div class="Accordion">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },

        props: {
            multipleOpen: {
                type: Boolean,
                default: true,
            },
        },
    }
</script>